import { SpinWheel } from "assets/icons";
import {
  DropdownSetting,
  InformationSetting,
  MultiLineSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";
import { getSoundsArray } from "util/getSoundsArray";
import { LINE_LIMIT_SPINNER, TOTAL_LINE_LIMIT_SPINNER } from "util/widgeTransformData";

import { InteractiveSpinner, InteractiveSpinnerState, startAngle } from "./Spinner";
import { SpinnerWordsList } from "./SpinnerWordsList";

export const InteractiveSpinnerWidget: WidgetType<InteractiveSpinnerState> = {
  name: "Spinner",
  component: InteractiveSpinner,
  icon: SpinWheel,
  showOnToolbar: true,
  sizing: {
    minWidth: 188,
    minHeight: 235,
    minAspectRatio: 0.8,
    maxAspectRatio: 0.8,
  },
  defaultState: {
    winningSegmentIndex: undefined,
    angleCurrent: startAngle,
    winningSegmentIndexes: [],
    remainingSegmentIndexes: [],
  },
  defaultSize: {
    aspectRatio: 0.7,
    widthPercentage: 30,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Add words to the wheel",
      },
    },
    nameList: {
      editor: MultiLineSetting,
      info: {
        lineLimit: LINE_LIMIT_SPINNER,
        totalLimit: TOTAL_LINE_LIMIT_SPINNER,
        settingName: "Words",
      },
      defaultValue: "Option 1\nOption 2",
    },
    saveWords: {
      editor: SpinnerWordsList,
      info: {
        settingName: "nameList",
      },
    },
    disableWinners: {
      editor: ToggleSetting,
      info: {
        label: "Disable Winners",
        infoMessage: "Disable winners until all other options have been chosen.",
      },
      defaultValue: false,
    },
    sound: {
      editor: ToggleSetting,
      info: {
        label: "Sound Effects",
      },
      defaultValue: true,
    },
    selectSound: {
      editor: DropdownSetting,
      info: {
        name: "Select Sound",
        options: getSoundsArray(),
      },
      defaultValue: "yoo-hoo.mp3",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.spinner,
        widgetDisplayName: "Spinner",
      },
    },
  },
  quickActions: {},
};
